import { Component, Input, OnChanges, OnInit, ViewChild }  from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { Inject, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

import {DataSource} from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import { Subject }  from 'rxjs/Subject';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

import { DateAdapter, NativeDateAdapter } from '@angular/material';

import { FireDataService } from '../fire-data.service';

import { CaseType } from '../case-type';
import { CASES } from '../case-list';
import { CaseData } from '../case-data';

export interface Data {}

@Component({
  selector: 'app-daily-activity',
  templateUrl: './daily-activity.component.html',
  styleUrls: ['./daily-activity.component.css']
})


export class DailyActivityComponent implements OnInit {

  caseForm: FormGroup;
  selectedCase: CaseType;
  caseData: CaseData;
  cases: CaseType[];
  caseFormButton = [{text:'Save', noShow: true}, {text:'Revert', noShow: true}, {text:'Delete', noShow: true}];
  listClasses = ['1L','1M','1N','2L','2M','2N','3L','3M','3N','4L','4M','4N','5L','5M','5N'];
  teacherTypes = [ {code: 'C', name: 'Curriculare'}, {code: 'S', name: 'Sostegno'} ];
  type = 'C';
  stdTime: any;
  settledDesc =  {'11': 'check se data di fine è effettiva', '15': 'check se tutto il giorno', '21': 'check se tutto il giorno'} ;
  selectClass: Object;
  teacherGroups: object;
  //classAllSchedule:object;
  previousCaseFormFields = {};
  isEditing: Boolean;

  showFieldFlags = {}       // used to pilot what variable fields must  be displayed, needs best solution in future releases !!!!!!!

  displayedColumns = ['regDate','caseId', 'firstTeacher', 'startDate', 'endDate','settled', 'classes', 'note'];
  dataSource: CaseDatabaseSource | null;
  caseDatabase = new CaseDatabase(this.fds);

  teachers: Observable<any>;
  private termTeacher = new Subject<string>();
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public dataLength: any; // For member counter on DOM.
  
  constructor(private fds: FireDataService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private location: Location, 
              dateAdapter: DateAdapter<NativeDateAdapter>) {
      //this.isLogged();
      dateAdapter.setLocale('it-IT');  // for MDdatePicker
      var row = {type: 'C', firstTeacher : '', startDate: Date.now(), endDate: Date.now(), previousEndDate: 0,
              settled: false, note: '', regDate: 0, classSchedule: [], selectClass: ''};
      this.isEditing = false;
      this.showFieldFlags['showClass'] = false, this.showFieldFlags['showScheduleGroup'] = false, this.showFieldFlags['showScheduleTeacher'] = false, this.showFieldFlags['showSettled'] = false
      this.stdTime = this.fds.stdTime;
      this.createForm(row);
   }

  ngOnInit(): void {
    
    this.cases = CASES;
    this.route.params.subscribe(params => {
        var parId = Number(params["id"]);
        function findId(el) {
          return parId == el.id;
        }
        this.selectedCase = this.cases[this.cases.findIndex(findId)]
        this.setShowFieldFlag(this.selectedCase.id);      // in future release this flags must be in the cases-list definition

    this.fds.getCaseData(parId)
          .subscribe(res => {
              this.dataSource = new CaseDatabaseSource(this.caseDatabase, this.paginator);
              this.dataLength = res.length;
        });
    });
  
    this.teachers = this.termTeacher
    .debounceTime(300)        // wait 300ms after each keystroke before considering the term
    .distinctUntilChanged()   // ignore if next search term is same as previous
    .switchMap(term => term   // switch to new observable each time the term changes
      // return the search observable
      ? this.fds.searchTeacher(this.type,term)
      // or the observable of empty array if there was no search term
      : Observable.of<any>([]))
    .catch(error => {
      // TODO: add real error handling
      console.log(error);
      return Observable.of<any[]>([]);
    });
    this.validateCaseForm();
  }

  private setShowFieldFlag(caseId) {
    switch (caseId) {
      case 15 :
        this.showFieldFlags['showClass'] = true, this.showFieldFlags['showScheduleGroup'] = true;
        break;
      case 21 :
        this.showFieldFlags['showScheduleTeacher'] = true;
        break;
      default :
        this.showFieldFlags['showClass'] = false, this.showFieldFlags['showScheduleGroup'] = false, 
        this.showFieldFlags['showScheduleTeacher'] = false, this.showFieldFlags['showSettled'] = false;
    } 
    console.log("Show field flags...", caseId, this.showFieldFlags)
  }


  private validateCaseForm() {
    this.caseForm.get('startDate').valueChanges
    .subscribe(val => {
      console.log("Fire startDate valueChange...")
      if (val > this.caseForm.get('endDate').value) {
        this.caseForm.get('endDate').setValue(val);
        this.caseForm.get('endDate').updateValueAndValidity();
        this.loadTeacherGroups(this.caseForm.get('selectClass'));
      }
    });

    this.caseForm.get('endDate').valueChanges
    .subscribe(val => {
      console.log("Fire endDate valueChange...")
      if (val < this.caseForm.get('startDate').value) {
        this.caseForm.get('startDate').setValue(val);
        this.caseForm.get('startDate').updateValueAndValidity();
        this.loadTeacherGroups(this.caseForm.get('selectClass'));
      }
    });

    this.caseForm.get('type').valueChanges
    .subscribe(val => {
      console.log("Fire type valueChange...")
        this.caseForm.get('teacher').setValue('');
        this.caseForm.get('teacher').updateValueAndValidity();
        this.loadTeacherGroups(this.caseForm.get('selectClass'));
    });

    this.caseForm.get('selectClass').valueChanges
    .subscribe(val => {
      console.log("Fire selectClass valueChange...", val)
      if (val) {
        this.fds.getClass(this.caseForm.get('selectClass').value, this.caseForm.get('startDate').value)
        .then(res => {
          //this.classAllSchedule = res;
          this.setClassSchedule(res);
        })
      } else {
        //this.classAllSchedule = [];
      }
      
    });

  }

  public selectedTeacher(teacher) {
    this.caseForm.get('teacher').setValue(teacher.payload.key);
    this.termTeacher.next('');
  }

  public validateTeacher(formControl) {
    console.log("Validate teacher...:", this.caseForm.get('type').value, formControl.value, this.previousCaseFormFields)
    return new Promise(resolve => {
      if (this.previousCaseFormFields['type'] !== this.caseForm.get('type').value || 
          this.previousCaseFormFields['teacher'] !== this.caseForm.get('teacher').value) {
        var self = this;
        console.log("Teacher or type are changed.......................")
        self.fds.getTeacher(this.caseForm.get('type').value, formControl.value,this.caseForm.get('startDate').value)
        .then(res => {
          if (!res) {
            console.log("Validate teacher NO res...:", res)
            self.caseForm.get('teacher').setValue('');
            self.caseForm.get('teacher').updateValueAndValidity();
            self.caseForm.get('selectClass').setValue('');
            self.caseForm.get('selectClass').updateValueAndValidity();
            this.setClassSchedule([]);
            //this.classAllSchedule = [];
          } /*else {
            if(this.selectedCase['id']==15) {
              console.log("Vediamo le classi di oggi...:", res)
              this.teacherGroups = res
            }
          } */
          console.log("Validate teacher FOUND res...:", res)
          this.loadTeacherGroups(this.caseForm.get('selectClass'));
          resolve()
        })
      } else {
        console.log("Skip validate teacher....");
        resolve();
      }
    });
  }

  public loadTeacherGroups(formControl) {
    console.log("Load teacher Group...:", formControl.value)
    return new Promise(resolve => {
      var self = this;
      self.fds.getTeacher(this.caseForm.get('type').value, this.caseForm.get('teacher').value,this.caseForm.get('startDate').value)
      .then(res => {
        console.log("Vediamo le classi di oggi...:", res)
        this.teacherGroups = res['groups'];
        if(!self.isEditing) {self.caseForm.get('selectClass').setValue('')}
        if(self.isEditing) {self.caseForm.get('selectClass').setValue(this.selectClass)}
        self.caseForm.get('selectClass').updateValueAndValidity();
        if(this.selectedCase['id']==15 || this.selectedCase['id']==21) {this.setClassSchedule(res['schedule']);}
        resolve()
      })
    });
  }

  public isLogged() {
    this.fds.user.subscribe(res => {
      if (res) {
        //console.log("Res...;",res)
        return true
      } else {
        this.router.navigate(["/login"]);
      }
    });
  }

    // Push a search term into the observable stream.
  public  search(term: string): void {
      this.termTeacher.next(term);
    }

  createForm(row) {
    this.caseForm = this.fb.group({
      type: row.firstTeacher.substr(0,1),
      teacher: [row.firstTeacher.substr(3), Validators.required, this.validateTeacher.bind(this) ],
      //teacher: [row.firstTeacher, Validators.required, {updateOn: 'blur', asyncValidators: [this.validateTeacher]} ],
      startDate: new Date(row.startDate),
      endDate: new Date(row.endDate),
      settled: row.settled,
      note: row.note,
      regDate: row.regDate,
      previousEndDate: row.previousEndDate,
      selectClass: row.selectClass,
      classSchedule: this.fb.array(row.classSchedule)  // example {'08:10': true, '09:10': false}
    });
  }
/*
  setClassSchedule2() {
    var scheduleArray = [];
    if (this.classAllSchedule) {
      for (var i in this.classAllSchedule) {
        var obj = {};
        obj[this.classAllSchedule[i]] = false;
        scheduleArray.push({'key': this.classAllSchedule[i], 'value': false})
      }
    }
    var classScheduleFormArray = this.fb.array(scheduleArray);
    console.log("Build schedule array...:", classScheduleFormArray.controls);
    this.previousCaseFormFields['type'] = this.caseForm.get('type').value;
    this.previousCaseFormFields['teacher'] = this.caseForm.get('teacher').value
    this.caseForm.setControl('classSchedule', classScheduleFormArray);
  }
*/
  setClassSchedule(schedule) {
    var scheduleArray = [];
    //this.caseForm.get('classSchedule').setValue(this.fb.array([]) );
    this.caseForm.setControl('classSchedule', this.fb.array([]) );
    if (schedule) {
      var items = this.caseForm.get('classSchedule') as FormArray;
      for (var i in schedule) {
        items.push(this.createItem({'schedule': schedule[i]['schedule'], 'value': false, 'group': schedule[i]['group']}));
      }
    }
    console.log("Build schedule array...:", items);
    this.previousCaseFormFields['type'] = this.caseForm.get('type').value;
    this.previousCaseFormFields['teacher'] = this.caseForm.get('teacher').value
    console.log("Show flags ...:", this.showFieldFlags)
  }

  createItem(obj): FormGroup {
    return this.fb.group({
      'schedule': obj.schedule,
      'scheduleGroup': obj.group,
      'scheduleCheck': obj.value
    });
  }

  ngOnChanges() {
    console.log("------> Form reset <--------")
    this.caseForm.reset({
      type: this.type,
      teacher: '',
      startDate: new Date(Date.now()),
      endDate: new Date(Date.now()),
      settled: '',
      note: '',
      regDate: 0,
      previousEndDate: 0,
      selectClass: ''
    });
    this.caseForm.setControl('classSchedule', this.fb.array([]) );
    this.caseFormButton[0].text ='Save';
    this.caseFormButton[1].noShow = true;
    this.caseFormButton[2].noShow = true;
    this.teacherGroups = [];
    this.isEditing = false
    this.previousCaseFormFields['type'] = '';
    this.previousCaseFormFields['teacher'] = '';
    this.validateCaseForm();
  }
//---------------------------------------------
// CRUD operation with ops parameter
// Save: insert (editDate = 0), 
// Update: update (editDate = current date), 
// Delete: remove (editDate = -1)
//---------------------------------------------
  onSubmit(ops) {
    var self = this;
    var editDate;
    if (ops=='Save') {editDate = 0 }
    if (ops=='Update') {editDate = Date.now() }
    if (ops=='Delete') {editDate = -1 }
      this.caseData = this.prepareSaveCase(editDate);
      this.fds.saveCase(this.caseData)
      .then(res => {
        console.log("Callback after ...:", ops)
        self.ngOnChanges();
      })
      .catch(err => {
        console.log("Save Error...:", err)
      });
  }


  prepareSaveCase(editDate): CaseData {
    const formModel = this.caseForm.value;
    console.log("Dati case form ...:", formModel)
    var currentDate = Date.now();
    if (formModel.regDate !== 0) {currentDate = formModel.regDate}
    const saveCaseData: CaseData = {
      caseId: Number(this.selectedCase.id),
      caseName: this.selectedCase.name,
      caseType: this.selectedCase.type,
      regDate: currentDate,
      editDate: editDate,
      firstTeacher: formModel.type + '::'+ formModel.teacher as string,
      secondTeacher: '',
      startDate: new Date(formModel.startDate.getFullYear(),formModel.startDate.getMonth() , formModel.startDate.getDate()).valueOf(),
      endDate: new Date(formModel.endDate.getFullYear(),formModel.endDate.getMonth() , formModel.endDate.getDate()).valueOf(),
      previousEndDate: formModel.previousEndDate,
      settled: formModel.settled as boolean,
      note: formModel.note as string,
      classes: {},
      regRecovery: {},
      regDateLinked: [],
      endDateLinked: [],
      absenceLinked: []
    };
    if (formModel.classSchedule.length !== 0) {
      for (var i in formModel.classSchedule) {
        if (formModel.classSchedule[i].scheduleCheck) {
          if (this.showFieldFlags['showScheduleGroup']) {saveCaseData.classes[formModel.classSchedule[i].schedule] = formModel.selectClass}
          if (this.showFieldFlags['showScheduleTeacher']) {saveCaseData.classes[formModel.classSchedule[i].schedule] = formModel.classSchedule[i].scheduleGroup}
        }
      }
    }
    return saveCaseData;
  }

  public revert() { 
      this.ngOnChanges(); 
  }

  public goBack() {
    this.location.back();

  }

handleRowClick(row) {
  console.log("Row click...:", row.classes);
  
  this.ngOnChanges();
  row['classSchedule'] = []
  var group;
  for (var item in row.classes) {
    group = row.classes[item];
    //row['classSchedule'].push(this.createItem({'schedule': item, 'value': true, 'group': row.classes[item]}));
  }
  
  if (row.classes) {
    row['selectClass'] = group;
    this.selectClass = group;
    console.log("class schedule...:", this.selectClass)
    this.isEditing = true;
  }
  //console.log("Row click...:", row);
    row['previousEndDate'] = row.endDate;
    this.caseFormButton[0].text ='Update';
  // this.caseFormButton[0].noShow = false;
    this.caseFormButton[1].noShow = false;
    this.caseFormButton[2].noShow = false;
    //this.selectedCase.id = row['caseId'];
    //this.selectedCase.name = row['caseName'];
    this.setShowFieldFlag('')
    this.setShowFieldFlag(this.selectedCase.id)
    
    this.createForm(row);
    //var items = this.caseForm.value.classSchedule
    var items = this.caseForm.get('classSchedule').value
    console.log("----> Items after CreateForm with row...:", items)
    for (var i in items) {
      console.log("TRY Control item...:", items[i])
      for (var r in row.classes) {
        if (items[i]['schedule'] == row.classes[r]['schedule']) {items[i]['scheduleCheck'] = row.classes[r]['scheduleCheck']}
        console.log("FOUND Control item...:", items[i])
      }
      
    }
    this.caseForm.get('teacher').setValue(row.firstTeacher.substr(3)) ;

  }

} // end of DailyActivityComponent  Class 

@Injectable()
//----------------------------------------------------------------
// CaseDatabase class: prepare data for cdk-table datasource and 
// change row management
//----------------------------------------------------------------
export class CaseDatabase {

    /* Stream that emits whenever the data has been modified. */
    public dataChange: BehaviorSubject<any> = new BehaviorSubject<CaseData[]>([]);
    get data(): CaseData[] {
        return this.dataChange.value; }

    // Connection to remote db.

    constructor(private fds: FireDataService) {
        this.fds.caseData
            .subscribe(data => this.dataChange.next(data));
    }
}
 
@Injectable()
//----------------------------------------------------------------
// CaseDatabase class: prepare data for cdk-table datasource and 
// change row management
//----------------------------------------------------------------
export class CaseDatabaseSource extends DataSource<CaseData> {


    constructor(
        private caseDatabase: CaseDatabase,
        private paginator: MatPaginator) {
        super();
    }


    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<CaseData[]> {

      const displayDataChanges = [
          this.caseDatabase.dataChange,
          this.paginator.page,
      ];

      return Observable
          .merge(...displayDataChanges) // Convert object to array with spread syntax.
          .map(() => {
              const dataSlice = this.caseDatabase.data.slice(); // Data removed from viewed page.

              // Get the page's slice per pageSize setting.
              const startIndex = this.paginator.pageIndex * this.paginator.pageSize;

              const dataLength = this.paginator.length;  // This is for the counter on the DOM.

              return dataSlice.splice(startIndex, this.paginator.pageSize);
          });
    }
    disconnect() {}
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/daily-activity/daily-activity.component.ts